module.exports = __webpack_public_path__ + "assets/1ae48c92d8a61b01137486ebc8501fc4.png";